import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiFacebook, FiTwitter, FiInstagram, FiLinkedin, FiYoutube } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="gradient-bg-3 text-white">
      {/* Newsletter Section */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="bg-white rounded-2xl p-8 max-w-md mx-auto"
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Follow us</h3>
            
            <div className="flex justify-center space-x-4 mb-6">
              {[FiFacebook, FiTwitter, FiInstagram, FiLinkedin, FiYoutube].map((Icon, index) => (
                <motion.a
                  key={index}
                  whileHover={{ scale: 1.1 }}
                  href="#"
                  className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center text-gray-600 hover:bg-pink-500 hover:text-white transition-colors"
                >
                  <SafeIcon icon={Icon} className="h-5 w-5" />
                </motion.a>
              ))}
            </div>

            <div className="space-y-3">
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full px-4 py-3 border border-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-pink-500 text-gray-900"
              />
              <motion.button
                whileHover={{ scale: 1.05 }}
                className="w-full bg-pink-500 text-white py-3 rounded-full font-semibold hover:bg-pink-600 transition-colors"
              >
                Subscribe Now
              </motion.button>
            </div>
            
            <p className="text-gray-500 text-sm mt-4">Designed from: England</p>
          </motion.div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-white/20 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-white/80">
                © {currentYear} All rights reserved.
              </p>
            </div>
            
            <div className="text-center md:text-right">
              <p className="text-white/80">
                Domain + Hosting + Design = {' '}
                <a 
                  href="https://account4web.ca" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-yellow-300 hover:text-yellow-200 transition-colors font-semibold"
                >
                  Account4Web Inc
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;